<template>
  <div class="order-info" v-if="!titleType">
    <div class="info-title" @click="handleInfo">
      <i :class="[infoShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
      {{ infoTitle }}
    </div>
    <div v-show="infoShow">
      <slot></slot>
    </div>
  </div>

  <div v-else>
    <div class="order-info" v-if="titleType === 'str'">
      <div class="info-title-str" @click="handleInfo">
        <slot name="strName"></slot>
        <i :class="[infoShow ? 'el-icon-arrow-down' : 'el-icon-arrow-right']"></i>
        <slot name="strStatus"></slot>
      </div>
      <div v-show="infoShow">
        <slot></slot>
      </div>
    </div>

    <div class="order-info" v-else>
      <div class="info-title-sub" @click="handleInfo">
        {{ infoTitle }}
        <i :class="[infoShow ? 'el-icon-arrow-down' : 'el-icon-arrow-right']"></i>
      </div>
      <div v-show="infoShow">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'info-collapse',
  props: {
    infoTitle: {
      type: String,
      default: ''
    },
    titleType: {
      type: String,
      default: ''
    },
    isInfoShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      infoShow: true
    }
  },
  watch: {
    isInfoShow () {
      this.infoShow = this.isInfoShow
    }
  },
  created () {
    this.infoShow = this.isInfoShow
  },
  methods: {
    handleInfo () {
      this.infoShow = !this.infoShow
    }
  }
}
</script>

<style lang="scss" scoped>
.info-title {
  font-size: $font-16;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 10px;

  i {
    font-weight: bold;
  }
}

.info-title-sub {
  font-size: $font-14;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 20px;
  color: $base-red;
  position: relative;

  i {
    font-weight: bold;
  }

  &:before {
    content: '';
    display: inline-block;
    height: 6px;
    width: 6px;
    position: absolute;
    left: -8px;
    top: 4px;
    border-radius: 6px;
    background-color: $base-red;
  }
}
.info-title-str {
  font-size: $font-12;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 20px;
}
</style>
